import React from 'react';
import ChevronLeft from "src/assets/chevron-left.svg";
import CrossIcon from "src/assets/cross.svg";
import { Button } from 'src/components';


interface Order {
    order_id_int: number;
    company_name: string;
    order_code: string;
    company_stockist_code: string;
    counter_code: string;
    counter_ff_div_lnk_id: number;
    uid: string;
    stockist_name: string;
    counter_company_location_id: number;
    state_code: string | null;
    actor_name: string;
    actor_code: string;
    actor_type: string;
    orderStatusHdr: {
        order_status_desc: string
    }
}

interface Props {
    order: Order | Order[] | null;
    isOpen: boolean;
    onClose: () => void;
}

const OrderModalComponent: React.FC<Props> = ({ order, isOpen, onClose }) => {
    if (!isOpen || !order) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto p-4">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-3xl">
                {/* Header */}
                <header className="flex rounded-tl-2xl rounded-tr-2xl items-center justify-between px-[1.19rem] py-5 bg-[#7450FA]">
                    <div className="flex items-center gap-[1.19rem]">
                        <div className="p-[0.19rem] cursor-pointer rounded-3xl bg-[#f4f7fa29]">
                            <img onClick={onClose} src={ChevronLeft} alt="Chevron Left" />
                        </div>
                        <h3 className="text-white">Order Details</h3>
                    </div>
                    <button onClick={onClose} className="p-[0.19rem] cursor-pointer bg-[#f4f7fa29] rounded-3xl">
                        <img src={CrossIcon} alt="Cross" />
                    </button>
                </header>

                {/* Content */}
                <div className="p-6">
                    <div className="overflow-x-auto rounded shadow border border-gray-200 max-h-[400px] overflow-y-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Order No</th>
                                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Company</th>
                                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Counter Code</th>
                                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Status</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {(order as Order[]).map((o) => (
                                    <tr key={o.uid} className="hover:bg-gray-50">
                                        <td className="px-4 py-2 text-sm">{o.order_code}</td>
                                        <td className="px-4 py-2 text-sm">{o.company_name}</td>
                                        <td className="px-4 py-2 text-sm">{o.counter_code}</td>
                                        <td className="px-4 py-2 text-sm text-yellow-600 font-semibold">{o?.orderStatusHdr?.order_status_desc}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-gray-50 px-6 py-3 rounded-b-lg text-right">
                    <Button
                        onClick={onClose}
                        className="border bg-primary text-white flex-1 py-[0.62rem]"
                    >
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default OrderModalComponent;